import { lazy } from 'react';

const TimeSheetExport = lazy(() => import('./TimeSheetExport'));

export default TimeSheetExport;
